<template>
  <el-menu
    @select="handleMenuSelect"
    :default-active.sync="activeLink"
    :mode="mode"
    :collapse="isCollapse"
    :unique-opened="true"
    background-color="transparent"
    class="main-navigation-menu"
    :class="{ 'nav-collapsed': isCollapse }"
  >
    <a
      href="/dashboard"
      @click.prevent
      v-if="
        roleId === 4 ||
        roleId === 6 ||
        roleId === 3 ||
        roleId === 7 ||
        roleId === 1 ||
        roleId === 2
      "
    >
      <el-menu-item
        index="/dashboard"
        class="global-color hover-text-color"
        :class="{ active: $route.path === '/dashboard' }"
      >
        <i class="mdi mdi-home-outline"></i>
        <span slot="title">{{ $t("dashboard") }}</span>
      </el-menu-item>
    </a>
    <a :href="navPresenceRoute" @click.prevent v-if="roleId === 2">
      <el-menu-item
        :index="navPresenceRoute"
        :class="{ active: $route.path === navPresenceRoute }"
        class="custom-menu-item"
      >
        <i
          class="mdi mdi-clock-check-outline"
          :style="{ color: clockColor + ' !important' }"
        ></i>
        <span class="my-presence-text">{{ $t("presence") }}</span>
      </el-menu-item>
    </a>
    <a :href="navPresenceRoute" @click.prevent v-if="roleId !== 2">
      <el-submenu
        :index="navPresenceRoute"
        popper-class="main-navigation-submenu"
        :class="{ active: $route.path === navPresenceRoute }"
        class="custom-submenu"
        @click.native="redirect(navPresenceRoute)"
      >
        <template slot="title"
          ><i
            class="mdi mdi-clock-check-outline"
            :style="{ color: clockColor + ' !important' }"
          ></i
          ><span class="my-presence-text">{{ $t("presence") }}</span></template
        >
        <el-menu-item
          index="#"
          :class="{ 'active-background-color': presence['Work'] }"
          @click="setPresence('Work')"
          v-loading="presenceLoadingOption == 'Work'"
          :disabled="isButtonDisabled"
        >
          <span
            slot="title"
            :class="{ 'work-color': presence['Work'] }"
            class="main-text-color"
            ><span
              class="mdi mdi-circle"
              :class="{ 'work-color': presence['Work'] }"
            ></span>
            {{ presence["Work"] ? $t("clock_out") : $t("clock_in") }}</span
          >
        </el-menu-item>
        <el-menu-item
          index="#"
          :class="{ 'active-background-color': presence['Break'] }"
          @click="setPresence('Break')"
          v-loading="presenceLoadingOption == 'Break'"
          :disabled="isButtonDisabled"
        >
          <span
            slot="title"
            :class="{ 'break-color': presence['Break'] }"
            class="main-text-color"
            ><span
              class="mdi mdi-circle"
              :class="{ 'break-color': presence['Break'] }"
            ></span>
            {{ presence["Break"] ? $t("break_stop") : $t("break_start") }}</span
          >
        </el-menu-item>
        <el-menu-item
          index="#"
          :class="{ 'active-background-color': presence['Private exit'] }"
          @click="setPresence('Private exit')"
          v-loading="presenceLoadingOption == 'Private exit'"
          :disabled="isButtonDisabled"
        >
          <span
            slot="title"
            :class="{ 'private-exit-color': presence['Private exit'] }"
            class="main-text-color"
            ><span
              class="mdi mdi-circle"
              :class="{ 'private-exit-color': presence['Private exit'] }"
            ></span>
            {{
              presence["Private exit"]
                ? $t("private_exit_stop")
                : $t("private_exit_start")
            }}</span
          >
        </el-menu-item>
        <el-menu-item
          index="#"
          :class="{ 'active-background-color': presence['Field work'] }"
          @click="setPresence('Field work')"
          v-loading="presenceLoadingOption == 'Field work'"
          :disabled="isButtonDisabled"
        >
          <span
            slot="title"
            :class="{ 'field-work-color': presence['Field work'] }"
            class="main-text-color"
            ><span
              class="mdi mdi-circle"
              :class="{ 'field-work-color': presence['Field work'] }"
            ></span>
            {{
              presence["Field work"]
                ? $t("field_work_stop")
                : $t("field_work_start")
            }}</span
          >
        </el-menu-item>
      </el-submenu>
    </a>
    <a :href="navPresenceRoute" @click.prevent>
      <el-menu-item
        :index="navPresenceRoute"
        class="custom-item hover-text-color"
        :class="{ active: $route.path === navPresenceRoute }"
      >
        <i
          class="mdi mdi-clock-check-outline"
          :style="{ color: clockColor + ' !important' }"
        ></i>
        <span slot="title" class="global-color">{{ $t("presence") }}</span>
      </el-menu-item>
    </a>
    <a href="/my-calendar" @click.prevent v-if="roleId === 5">
      <el-menu-item
        index="/my-calendar"
        class="global-color hover-text-color"
        :class="{ active: $route.path === '/my-calendar' }"
      >
        <i class="mdi mdi-calendar-month-outline"></i>
        <span slot="title">{{ $t("calendar") }}</span>
      </el-menu-item>
    </a>
    <a
      href="/calendar"
      @click.prevent
      v-if="
        $store.getters.user.roleId === 4 ||
        $store.getters.user.roleId === 6 ||
        $store.getters.user.roleId === 3 ||
        roleId === 7 ||
        roleId === 1 ||
        roleId === 2
      "
    >
      <el-menu-item
        index="/calendar"
        class="global-color hover-text-color"
        :class="{ active: $route.path === '/calendar' }"
      >
        <i class="mdi mdi-calendar-month-outline"></i>
        <span slot="title">{{ $t("calendar") }}</span>
      </el-menu-item>
    </a>
    <a
      v-if="
        roleId === 4 ||
        roleId === 6 ||
        roleId === 3 ||
        roleId === 7 ||
        roleId === 1 ||
        roleId === 2
      "
    >
      <el-submenu
        v-if="
          roleId === 4 ||
          roleId === 6 ||
          roleId === 3 ||
          roleId === 7 ||
          roleId === 1 ||
          roleId === 2
        "
        popper-class="main-navigation-submenu"
        class="custom-submenu-reports"
        :index="'/shift-reports'"
      >
        <template #title>
          <i class="mdi mdi-chart-line"></i>
          <span>{{ $t("reports") }}</span>
        </template>
        <el-menu-item
          v-if="
            roleId === 6 ||
            roleId === 3 ||
            roleId === 7 ||
            roleId === 1 ||
            roleId === 2
          "
          :index="'/presence-reports'"
        >
          <router-link
            to="/presence-reports"
            :class="{ active: $route.path === '/presence-reports' }"
            class="custom-color"
          >
            <i class="mdi mdi-clock-check-outline custom-icon"></i>
            <span class="main-text-color">{{ $t("presence_reports") }}</span>
          </router-link>
        </el-menu-item>
        <el-menu-item
          v-if="(roleId === 1 || roleId === 2) && companyId === 1"
          :index="'/non-rounded-presence-reports'"
        >
          <router-link
            to="non-rounded-presence-reports"
            :class="{ active: $route.path === 'non-rounded-presence-reports' }"
            class="custom-color"
          >
            <i class="mdi mdi-clock-check-outline custom-icon"></i>
            <span class="main-text-color">{{
              $t("non_rounded_presence_reports")
            }}</span>
          </router-link>
        </el-menu-item>
        <el-menu-item
          v-if="
            roleId === 6 ||
            roleId === 3 ||
            roleId === 7 ||
            roleId === 1 ||
            roleId === 2
          "
          :index="'/calendar-reports'"
        >
          <router-link
            to="/calendar-reports"
            :class="{ active: $route.path === '/calendar-reports' }"
            class="custom-color"
          >
            <i class="mdi mdi-calendar-month-outline"></i>
            <span class="main-text-color">{{ $t("calendar_reports") }}</span>
          </router-link>
        </el-menu-item>

        <el-menu-item :index="'/shift-reports'">
          <router-link
            to="/shift-reports"
            :class="{ active: $route.path === '/shift-reports' }"
            class="custom-color"
          >
            <i class="mdi mdi-calendar-check"></i>
            <span class="main-text-color">{{ $t("shift_reports") }}</span>
          </router-link>
        </el-menu-item>

        <el-menu-item
          v-if="roleId === 3 || roleId === 7 || roleId === 1 || roleId === 2"
          :index="'/administrator-reports'"
        >
          <router-link
            to="/administrator-reports"
            :class="{ active: $route.path === '/administrator-reports' }"
            class="custom-color"
          >
            <i class="mdi mdi-calendar-range-outline"></i>
            <span class="main-text-color">{{
              $t("administrators_report")
            }}</span>
          </router-link>
        </el-menu-item>
        <el-menu-item
          v-if="roleId === 3 && companyId === 1"
          :index="'/sentice-reports'"
        >
          <router-link
            to="/sentice-reports"
            :class="{ active: $route.path === '/sentice-reports' }"
            class="custom-color"
          >
            <i class="mdi mdi-calendar-month-outline"></i>
            <span class="main-text-color">{{ $t("sentice_report") }}</span>
          </router-link>
        </el-menu-item>
      </el-submenu>
    </a>
    <a v-if="roleId === 3 || roleId === 7 || roleId === 1">
      <el-submenu
        v-if="roleId === 3 || roleId === 7 || roleId === 1"
        popper-class="main-navigation-submenu"
        class="custom-submenu-reports"
        :index="'/team'"
      >
        <template #title>
          <i class="mdi mdi-cog-outline"></i>
          <span>{{ $t("settings") }}</span>
        </template>
        <el-menu-item
          v-if="roleId === 3 || roleId === 7 || roleId === 1"
          :index="'/users'"
        >
          <router-link
            to="/users"
            :class="{ active: $route.path === '/users' }"
            class="custom-color"
          >
            <i class="mdi mdi-account-multiple"></i>
            <span class="main-text-color">{{ $t("users") }}</span>
          </router-link>
        </el-menu-item>
        <el-menu-item
          v-if="roleId === 3 || roleId === 7 || roleId === 1"
          :index="'/departments'"
        >
          <router-link
            to="/departments"
            :class="{ active: $route.path === '/departments' }"
            class="custom-color"
          >
            <i class="mdi mdi-account-network-outline"></i>
            <span class="main-text-color">{{ $t("departments") }}</span>
          </router-link>
        </el-menu-item>
        <el-menu-item
          v-if="roleId === 3 || roleId === 7 || roleId === 1"
          :index="'/teams'"
        >
          <router-link
            to="/teams"
            :class="{ active: $route.path === '/teams' }"
            class="custom-color"
          >
            <i class="mdi mdi-sitemap-outline"></i>
            <span class="main-text-color">{{ $t("teams") }}</span>
          </router-link>
        </el-menu-item>
        <el-menu-item
          v-if="roleId === 3 || roleId === 7 || roleId === 1"
          :index="'/holiday'"
        >
          <router-link
            to="/holiday"
            :class="{ active: $route.path === '/holiday' }"
            class="custom-color"
          >
            <i class="el-icon-magic-stick"></i>
            <span class="main-text-color">{{ $t("holidays") }}</span>
          </router-link>
        </el-menu-item>
        <el-menu-item
          v-if="roleId === 3 || roleId === 7 || roleId === 1"
          :index="'/nationality-religion-view'"
        >
          <router-link
            to="/nationality-religion-view"
            :class="{ active: $route.path === '/nationality-religion-view' }"
            class="custom-color"
          >
            <i class="mdi mdi-earth"></i>
            <span class="main-text-color">{{
              $t("nationality_religion")
            }}</span>
          </router-link>
        </el-menu-item>
        <!-- Start Company submenu -->
        <el-submenu
          v-if="roleId === 3 || roleId === 7 || roleId === 1"
          :index="'/company'"
          popper-class="main-navigation-submenu"
        >
          <template #title>
            <i class="mdi mdi-domain cutom-company-icon"></i>
            <span class="custom-span-color-submenu">{{ $t("company") }}</span>
          </template>
          <el-menu-item :index="'/company-details'" v-if="roleId === 1">
            <router-link
              to="/company-details"
              :class="{ active: $route.path === '/company-details' }"
              class="custom-color"
            >
              <i class="mdi mdi-domain"></i>
              <span class="main-text-color">{{ $t("details") }}</span>
            </router-link>
          </el-menu-item>
          <el-menu-item
            :index="'/settings'"
            v-if="roleId === 7 || roleId === 1"
          >
            <router-link
              to="/settings"
              :class="{ active: $route.path === '/settings' }"
              class="custom-color"
            >
              <i class="mdi mdi-cog-outline"></i>
              <span class="main-text-color">{{ $t("settings") }}</span>
            </router-link>
          </el-menu-item>
          <el-menu-item :index="'/gates'" v-if="roleId === 7 || roleId === 1">
            <router-link
              to="/gates"
              :class="{ active: $route.path === '/gates' }"
              class="custom-color"
            >
              <i class="mdi mdi-gate"></i>
              <span class="main-text-color">{{ $t("gates") }}</span>
            </router-link>
          </el-menu-item>
          <el-menu-item :index="'/document-templates'">
            <router-link
              to="/document-templates"
              :class="{ active: $route.path === '/document-templates' }"
              class="custom-color"
            >
              <i class="mdi mdi-file-document-outline"></i>
              <span class="main-text-color">{{
                $t("document_templates")
              }}</span>
            </router-link>
          </el-menu-item>
        </el-submenu>
        <!-- End Company submenu -->
      </el-submenu>
    </a>
    <a href="/teams" @click.prevent v-if="roleId === 6">
      <el-menu-item
        index="/teams"
        class="global-color hover-text-color"
        :class="{ active: $route.path === '/teams' }"
      >
        <i class="mdi mdi-sitemap-outline"></i>
        <span slot="title">{{ $t("teams") }}</span>
      </el-menu-item>
    </a>
    <a href="/my-profile" v-if="roleId === 5" @click.prevent>
      <el-menu-item
        index="/my-profile"
        class="global-color hover-text-color"
        :class="{ active: $route.path === '/my-profile' }"
      >
        <i class="mdi mdi-account-outline"></i>
        <span slot="title">{{ $t("my_profile") }}</span>
      </el-menu-item>
    </a>
  </el-menu>
</template>

<script>
import { detect } from "detect-browser";
const browser = detect();

export default {
  name: "Nav",
  props: ["mode", "isCollapse"],

  data() {
    return {
      isIe: true,
      isEdge: true,
      activeLink: null,
    };
  },
  computed: {
    navPresenceRoute() {
      return this.roleId === 5 ? "/my-presence" : "/presence";
    },
    roleId() {
      return this.$store.getters.user.roleId;
    },
    companyId() {
      return this.$store.getters.user.companyId;
    },
    presence() {
      return this.$store.getters.presence;
    },
    clockColor() {
      return this.$store.getters.currentPresenceColor;
    },
    presenceLoadingOption() {
      return this.$store.getters.presenceLoadingOption;
    },
    isButtonDisabled() {
      return this.presenceLoadingOption !== null;
    },
  },
  methods: {
    handleMenuSelect(index, indexPath) {
      const currentRoute = this.$route.path;
      if (index === currentRoute || index.includes("#")) {
        // Same route, prevent navigation
        return;
      }

      // Different route, proceed with navigation
      this.$router.push(index);
      this.$emit("push-page", { page: index });
    },

    redirect(route) {
      if (route === this.$route.path) {
        return;
      }
      this.$router.push(route);
    },
    setLink(path) {
      this.activeLink = path;
      if (this.roleId !== 2) {
        this.$store.dispatch("fetchMyCurrentPresence");
      }
    },

    setPresence(option) {
      this.$store.dispatch("setPresenceAction", option);
    },
  },
  created() {
    if (browser.name !== "ie") this.isIe = false;
    if (browser.name !== "edge") this.isEdge = false;

    this.setLink(this.$router.currentRoute.path);
    this.$router.afterEach((to, from) => {
      this.setLink(this.$router.currentRoute.path);
      //console.log('afterEach', to, from)
    });
    //console.log('this.$router.currentRoute.path', this.$router.currentRoute.path)
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables";

.el-menu {
  border: none;
}
.el-menu::before,
.el-menu::after {
  display: none;
}
.el-submenu,
.el-menu-item {
  .mdi {
    vertical-align: middle;
    margin-right: 5px;
    display: inline-block;
    width: 24px;
    text-align: center;
    font-size: 18px;
  }
}

.collapse-menu-btn {
  button {
    border-radius: 4px;
    border: none;
    color: $text-color-accent;
    background: lighten($text-color-accent, 30);
    font-weight: 600;
    padding: 4px 8px;
    margin-top: 20px;
    font-size: 12px;
    margin-left: 20px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-align: center;

    i {
      font-size: 14px;
      margin-right: 5px;
    }
  }

  &.collapsed {
    button {
      margin-left: 17px;

      i {
        margin-right: -2px;
      }
    }
  }
}

.hide-collapse {
  display: none !important;
}
.custom-color {
  color: #591df1 !important;
}
.custom-color.active span {
  color: #591df1 !important;
}
.cutom-company-icon {
  color: #777777 !important;
}
.custom-span-color-submenu {
  color: #777777 !important;
}
</style>

<style lang="scss">
@import "../assets/scss/_variables";

.main-navigation-menu {
  transition: width 0.5s;

  &:not(.el-menu--collapse) {
    .el-submenu__title,
    .el-menu-item {
      height: 40px;
      line-height: 40px;
      background-color: transparent !important;
      border-bottom: none;
    }

    &:not(.el-menu--horizontal) {
      .el-menu-item,
      .el-submenu {
        position: relative;

        &::before {
          content: "";
          display: block;
          width: 0px;
          height: 1px;
          position: absolute;
          bottom: 10px;
          left: 30px;
          background: $text-color;
          z-index: 1;
          opacity: 0;
          transition: all 0.7s cubic-bezier(0.55, 0, 0.1, 1);
        }

        &.is-active {
          &::before {
            background: $text-color-accent;
          }
        }
      }
    }

    i.mdi.mdi-clock-check-outline {
      color: $main-text-color !important;
    }

    .my-presence-text {
      color: $main-text-color;
    }

    .active {
      background-color: #f5f6fc !important;
      color: $text-color-purple !important;

      .my-presence-text,
      .mdi,
      .el-icon-arrow-down {
        color: $text-color-purple !important;
      }
    }

    @media screen and (min-width: 1241px) {
      .custom-item {
        display: none;
      }
    }
    @media screen and (max-width: 1240px) {
      .custom-submenu {
        display: none;
      }

      .custom-item.is-active {
        .global-color,
        .global-color {
          color: $text-color-purple !important;
        }
      }

      li.el-menu-item.custom-item.is-active {
        background-color: #f5f6fc !important;
      }
      li.el-menu-item.global-color.is-active {
        background-color: #f5f6fc !important;
      }
    }

    .el-submenu.is-opened {
      position: relative;

      &::after {
        content: "";
        display: block;
        width: 2px;
        position: absolute;
        top: 40px;
        bottom: 10px;
        left: 31px;
        background: $text-color;
        z-index: 1;
      }

      &::before {
        display: none;
      }

      .el-menu-item,
      .el-submenu {
        &::before,
        &::after {
          display: none;
        }
      }
    }

    .el-menu-item-group__title {
      padding: 15px 0 0px 20px;
      color: transparentize($text-color, 0.65);
    }
  }
  .el-submenu__title,
  .el-menu-item:not(.is-active) {
    color: $text-color;

    i {
      color: $text-color;
    }
  }

  &.el-menu--collapse {
    .el-menu-item-group__title {
      padding: 15px 0 0px 0px;
      width: 100%;
      text-align: center;
    }

    .el-submenu__title:hover,
    .el-menu-item:hover {
      background-color: rgba(0, 0, 0, 0.05) !important;
    }
  }

  &.el-menu--horizontal {
    white-space: nowrap;

    overflow: hidden;
    display: table;

    & > * {
      display: inline-block;
    }
  }

  &.nav-collapsed {
    .el-menu-item,
    .el-submenu__title {
      & > span {
        display: none;
      }
    }
  }
}

.main-navigation-submenu {
  .el-menu {
    background: #fff !important;

    .el-menu-item:not(.is-active) {
      color: $text-color;
    }
    .el-menu-item:hover {
      background-color: transparentize($background-color, 0.3) !important;
    }
  }

  .active-background-color {
    background-color: rgba(243, 247, 250, 0.7) !important;
  }

  .mdi-circle {
    color: #bec2c4;
  }

  .work-color {
    color: #2786fb;
  }
  .break-color {
    color: #1dc9b7;
  }
  .private-exit-color {
    color: #ffb822;
  }
  .field-work-color {
    color: purple;
  }
}

.global-color,
.global-color {
  color: $main-text-color !important;
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none;
}

li.el-submenu.custom-submenu:hover {
  span,
  .el-submenu__icon-arrow {
    color: $text-color-purple;
  }
}

.hover-text-color:hover {
  span,
  .mdi {
    color: $text-color-purple !important;
  }
}
.custom-submenu.el-submenu,
.custom-submenu-reports.el-submenu {
  .el-submenu__icon-arrow.el-icon-arrow-down {
    position: static !important;
    margin-top: 0;
    margin-left: 5px;
  }
}
.main-navigation-menu.el-menu {
  a {
    text-decoration: none;
  }
}
a {
  text-decoration: none;
}
.main-navigation-menu:not(.el-menu--collapse)
  .el-menu-item.is-active
  .custom-icon {
  color: #591df1 !important;
}

.main-navigation-menu:not(.el-menu--collapse) .el-menu-item .custom-icon {
  color: #5f6281;
}
</style>
